import { z } from "zod";

export const ProfileItemSchema = z
  .object({
    Id: z.string(),
    Login: z.string(),
    AccountId: z.string().optional(),
    FullName: z.string().optional(),
    LocationNumbers: z.string().array().optional(),
    FirstName: z.string().optional(),
    LastName: z.string().optional(),
    DisplayName: z.string().optional(),
    WorkPhone: z.string().optional(),
    MobilePhone: z.string().optional(),
    Department: z.string().optional(),
    Company: z.string().optional(),
    JobTitle: z.string().optional(),
    GenderCode: z.number().optional(),
    BirthDate: z.string().optional(),
    IsAdmin: z.boolean().optional(),
    Roles: z.string().array().optional(),
  })
  .transform((data) => ({
    ...data,
    FullName: data.FullName || `${data.FirstName} ${data.LastName}`,
  }));

export type ProfileItemType = z.infer<typeof ProfileItemSchema>;
